// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Equity Dashboard - Professional Trading Platform Style */

.equity-container {
  padding: 1rem;
  max-width: 100%;
  margin: 0 auto;
  background: #f5f7fa;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Inter', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-feature-settings: 'tnum' 1; /* Tabular numbers for better alignment */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.9375rem; /* Slightly smaller base font */
}

/* Header Section */
.equity-header {
  margin-bottom: 1.5rem;
}

.equity-header h1 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.75rem 0;
  letter-spacing: -0.02em;
}

.equity-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 0.75rem;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
}

.equity-control-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.equity-control-group label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  white-space: nowrap;
}

.equity-select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  background: #ffffff;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 150px;
}

.equity-select:hover {
  border-color: #9ca3af;
}

.equity-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

input.equity-select[type='date'] {
  min-width: 150px;
  font-family: inherit;
  color-scheme: light;
}

.equity-toggle-group {
  display: flex;
  gap: 0;
  background: #f3f4f6;
  border-radius: 6px;
  padding: 2px;
  border: 1px solid #e5e7eb;
}

.equity-toggle-group button {
  padding: 0.5rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  white-space: nowrap;
}

.equity-toggle-group button:hover {
  color: #1a1a1a;
  background: #ffffff;
}

.equity-toggle-group button.active {
  background: #ffffff;
  color: #1a1a1a;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.equity-export-btn {
  padding: 0.5rem 1rem;
  background: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: auto;
}

.equity-export-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}

.equity-export-btn:active {
  transform: translateY(0);
}

.equity-currency-toggle {
  padding: 0.5rem 1rem;
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: 0.5rem;
}

.equity-currency-toggle:hover:not(:disabled) {
  background: #e5e7eb;
}

.equity-currency-toggle.active {
  background: #10b981;
  color: #ffffff;
  border-color: #10b981;
}

.equity-currency-toggle.active:hover {
  background: #059669;
  border-color: #059669;
}

.equity-currency-toggle:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Summary Cards */
.equity-summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.equity-card {
  background: #ffffff;
  padding: 0.875rem;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  transition: all 0.2s;
  position: relative;
  cursor: help;
}

.equity-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.equity-card[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #1a1a1a;
  color: #ffffff;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  white-space: nowrap;
  z-index: 1000;
  margin-bottom: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}

.equity-card[title]:hover::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1a1a1a;
  z-index: 1001;
  margin-bottom: -5px;
}

.equity-card-label {
  font-size: 0.6875rem;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.375rem;
}

.equity-card-value {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-variant-numeric: tabular-nums;
}

.equity-card-value > span:first-child {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-wrap: wrap;
}

.equity-card-value > .equity-card-arrow {
  display: inline-block;
}

.equity-card-value > .equity-card-change {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-wrap: wrap;
}

.equity-card.positive .equity-card-value {
  color: #059669;
}

.equity-card.negative .equity-card-value {
  color: #dc2626;
}

.equity-card-change {
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.25rem;
}

.equity-card-change.positive {
  color: #059669;
}

.equity-card-change.negative {
  color: #dc2626;
}

.equity-card-arrow {
  font-size: 1rem;
  font-weight: 700;
  display: inline-block;
}

.equity-card-percent {
  font-size: 0.875rem;
  font-weight: 500;
  margin-left: 0.25rem;
}

/* Table Container */
.equity-table-container {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  overflow: visible;
  position: relative;
}

.equity-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
  min-width: 800px;
}

.equity-table thead {
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.equity-table th {
  padding: 0.625rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  transition: background-color 0.2s;
  font-variant-numeric: tabular-nums;
}

.equity-table th:not(:first-child) {
  text-align: right;
}

.equity-table th:hover {
  background: #f3f4f6;
}

.equity-sort-icon {
  margin-left: 0.5rem;
  color: #9ca3af;
  font-size: 0.75rem;
}

.equity-table th:hover .equity-sort-icon {
  color: #6b7280;
}

.equity-table tbody tr {
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.15s;
}

.equity-table tbody tr:hover {
  background: #f9fafb;
}

.equity-table tbody tr:last-child {
  border-bottom: none;
}

.equity-table td {
  padding: 0.625rem 0.75rem;
  color: #1a1a1a;
  white-space: nowrap;
  position: relative;
  cursor: help;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.equity-table td:first-child {
  text-align: left;
}

.equity-table td[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #1a1a1a;
  color: #ffffff;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  white-space: pre-line;
  z-index: 1000;
  min-width: 200px;
  max-width: 300px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  margin-bottom: 0.5rem;
  line-height: 1.4;
  text-align: left;
}

.equity-table td[title]:hover::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1a1a1a;
  z-index: 1001;
  margin-bottom: -5px;
}

@media (max-width: 768px) {
  .equity-table td[title]:hover::after {
    left: auto;
    right: 0;
    transform: none;
    max-width: 250px;
  }

  .equity-table td[title]:hover::before {
    left: auto;
    right: 1rem;
    transform: none;
  }
}

.equity-sticky-col {
  position: sticky;
  left: 0;
  background: #ffffff;
  z-index: 5;
  font-weight: 500;
  border-right: 1px solid #e5e7eb;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05);
}

.equity-table thead .equity-sticky-col {
  background: #f9fafb;
  z-index: 15;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05), 0 2px 4px rgba(0, 0, 0, 0.05);
}

.equity-table tbody tr:hover .equity-sticky-col {
  background: #f9fafb;
}

/* Color coding for differences */
.equity-table td.positive {
  color: #059669;
  font-weight: 600;
  background-color: rgba(5, 150, 105, 0.05);
}

.equity-table td.negative {
  color: #dc2626;
  font-weight: 600;
  background-color: rgba(220, 38, 38, 0.05);
}

.equity-table tbody tr:hover td.positive {
  background-color: rgba(5, 150, 105, 0.1);
}

.equity-table tbody tr:hover td.negative {
  background-color: rgba(220, 38, 38, 0.1);
}

.equity-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: #9ca3af;
  font-style: italic;
}

/* Loading and Error States */
.equity-loading,
.equity-error {
  padding: 3rem;
  text-align: center;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
}

.equity-loading {
  color: #6b7280;
}

.equity-error {
  color: #dc2626;
  background: #fef2f2;
  border-color: #fecaca;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .equity-table-container {
    max-height: calc(100vh - 350px);
  }
}

@media (max-width: 768px) {
  .equity-container {
    padding: 1rem;
  }

  .equity-header h1 {
    font-size: 1.5rem;
  }

  .equity-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .equity-control-group {
    flex-direction: column;
    align-items: stretch;
  }

  .equity-export-btn {
    margin-left: 0;
    width: 100%;
  }

  .equity-summary-cards {
    grid-template-columns: 1fr;
  }

  .equity-table-container {
    overflow-x: auto;
  }

  .equity-card-value {
    font-size: 1.25rem;
  }

  .equity-table {
    font-size: 0.8125rem;
  }

  .equity-table td,
  .equity-table th {
    padding: 0.75rem 0.875rem;
  }
}

@media (max-width: 480px) {
  .equity-card-value {
    font-size: 1.125rem;
  }

  .equity-table {
    font-size: 0.75rem;
    min-width: 700px;
  }

  .equity-table td,
  .equity-table th {
    padding: 0.625rem 0.75rem;
  }
}

/* Dark mode support (optional, can be enabled later) */
@media (prefers-color-scheme: dark) {
  /* Dark mode styles can be added here if needed */
}

/* Print styles */
@media print {
  .equity-controls,
  .equity-export-btn {
    display: none;
  }

  .equity-container {
    background: #ffffff;
    padding: 0;
  }

  .equity-table-container {
    box-shadow: none;
    border: 1px solid #000;
  }
}
/* ---- Deposit / Note styling ---- */
.equity2-deposit-row {
  background-color: #f0f9ff;
}

.equity2-deposit-row:hover {
  background-color: #e0f2fe !important;
}

.equity2-note-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.equity2-note-deposit {
  background-color: #dbeafe;
  color: #1d4ed8;
  border: 1px solid #93c5fd;
}
`, "",{"version":3,"sources":["webpack://./src/Equity.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,uKAAuK;EACvK,+BAA+B,EAAE,yCAAyC;EAC1E,mCAAmC;EACnC,kCAAkC;EAClC,oBAAoB,EAAE,+BAA+B;AACvD;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;IACR,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,wEAAwE;AAC1E;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;EAC3B;AACF;;AAEA,uDAAuD;AACvD;EACE,iDAAiD;AACnD;;AAEA,iBAAiB;AACjB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;AACF;AACA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":["/* Equity Dashboard - Professional Trading Platform Style */\n\n.equity-container {\n  padding: 1rem;\n  max-width: 100%;\n  margin: 0 auto;\n  background: #f5f7fa;\n  min-height: 100vh;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Inter', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-feature-settings: 'tnum' 1; /* Tabular numbers for better alignment */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 0.9375rem; /* Slightly smaller base font */\n}\n\n/* Header Section */\n.equity-header {\n  margin-bottom: 1.5rem;\n}\n\n.equity-header h1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0 0 0.75rem 0;\n  letter-spacing: -0.02em;\n}\n\n.equity-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  padding: 0.75rem;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n}\n\n.equity-control-group {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.equity-control-group label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #4b5563;\n  white-space: nowrap;\n}\n\n.equity-select {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  background: #ffffff;\n  color: #1a1a1a;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 150px;\n}\n\n.equity-select:hover {\n  border-color: #9ca3af;\n}\n\n.equity-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\ninput.equity-select[type='date'] {\n  min-width: 150px;\n  font-family: inherit;\n  color-scheme: light;\n}\n\n.equity-toggle-group {\n  display: flex;\n  gap: 0;\n  background: #f3f4f6;\n  border-radius: 6px;\n  padding: 2px;\n  border: 1px solid #e5e7eb;\n}\n\n.equity-toggle-group button {\n  padding: 0.5rem 1rem;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.equity-toggle-group button:hover {\n  color: #1a1a1a;\n  background: #ffffff;\n}\n\n.equity-toggle-group button.active {\n  background: #ffffff;\n  color: #1a1a1a;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.equity-export-btn {\n  padding: 0.5rem 1rem;\n  background: #3b82f6;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-left: auto;\n}\n\n.equity-export-btn:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n}\n\n.equity-export-btn:active {\n  transform: translateY(0);\n}\n\n.equity-currency-toggle {\n  padding: 0.5rem 1rem;\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-left: 0.5rem;\n}\n\n.equity-currency-toggle:hover:not(:disabled) {\n  background: #e5e7eb;\n}\n\n.equity-currency-toggle.active {\n  background: #10b981;\n  color: #ffffff;\n  border-color: #10b981;\n}\n\n.equity-currency-toggle.active:hover {\n  background: #059669;\n  border-color: #059669;\n}\n\n.equity-currency-toggle:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Summary Cards */\n.equity-summary-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.equity-card {\n  background: #ffffff;\n  padding: 0.875rem;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  transition: all 0.2s;\n  position: relative;\n  cursor: help;\n}\n\n.equity-card:hover {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transform: translateY(-1px);\n}\n\n.equity-card[title]:hover::after {\n  content: attr(title);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1a1a1a;\n  color: #ffffff;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  white-space: nowrap;\n  z-index: 1000;\n  margin-bottom: 0.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  pointer-events: none;\n}\n\n.equity-card[title]:hover::before {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #1a1a1a;\n  z-index: 1001;\n  margin-bottom: -5px;\n}\n\n.equity-card-label {\n  font-size: 0.6875rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.375rem;\n}\n\n.equity-card-value {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1a1a1a;\n  line-height: 1.4;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.equity-card-value > span:first-child {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  flex-wrap: wrap;\n}\n\n.equity-card-value > .equity-card-arrow {\n  display: inline-block;\n}\n\n.equity-card-value > .equity-card-change {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  flex-wrap: wrap;\n}\n\n.equity-card.positive .equity-card-value {\n  color: #059669;\n}\n\n.equity-card.negative .equity-card-value {\n  color: #dc2626;\n}\n\n.equity-card-change {\n  font-size: 0.875rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-top: 0.25rem;\n}\n\n.equity-card-change.positive {\n  color: #059669;\n}\n\n.equity-card-change.negative {\n  color: #dc2626;\n}\n\n.equity-card-arrow {\n  font-size: 1rem;\n  font-weight: 700;\n  display: inline-block;\n}\n\n.equity-card-percent {\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-left: 0.25rem;\n}\n\n/* Table Container */\n.equity-table-container {\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  overflow: visible;\n  position: relative;\n}\n\n.equity-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n  min-width: 800px;\n}\n\n.equity-table thead {\n  background: #f9fafb;\n  border-bottom: 2px solid #e5e7eb;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.equity-table th {\n  padding: 0.625rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n  font-variant-numeric: tabular-nums;\n}\n\n.equity-table th:not(:first-child) {\n  text-align: right;\n}\n\n.equity-table th:hover {\n  background: #f3f4f6;\n}\n\n.equity-sort-icon {\n  margin-left: 0.5rem;\n  color: #9ca3af;\n  font-size: 0.75rem;\n}\n\n.equity-table th:hover .equity-sort-icon {\n  color: #6b7280;\n}\n\n.equity-table tbody tr {\n  border-bottom: 1px solid #f3f4f6;\n  transition: background-color 0.15s;\n}\n\n.equity-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.equity-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.equity-table td {\n  padding: 0.625rem 0.75rem;\n  color: #1a1a1a;\n  white-space: nowrap;\n  position: relative;\n  cursor: help;\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n}\n\n.equity-table td:first-child {\n  text-align: left;\n}\n\n.equity-table td[title]:hover::after {\n  content: attr(title);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1a1a1a;\n  color: #ffffff;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  white-space: pre-line;\n  z-index: 1000;\n  min-width: 200px;\n  max-width: 300px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  pointer-events: none;\n  margin-bottom: 0.5rem;\n  line-height: 1.4;\n  text-align: left;\n}\n\n.equity-table td[title]:hover::before {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #1a1a1a;\n  z-index: 1001;\n  margin-bottom: -5px;\n}\n\n@media (max-width: 768px) {\n  .equity-table td[title]:hover::after {\n    left: auto;\n    right: 0;\n    transform: none;\n    max-width: 250px;\n  }\n\n  .equity-table td[title]:hover::before {\n    left: auto;\n    right: 1rem;\n    transform: none;\n  }\n}\n\n.equity-sticky-col {\n  position: sticky;\n  left: 0;\n  background: #ffffff;\n  z-index: 5;\n  font-weight: 500;\n  border-right: 1px solid #e5e7eb;\n  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05);\n}\n\n.equity-table thead .equity-sticky-col {\n  background: #f9fafb;\n  z-index: 15;\n  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05), 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.equity-table tbody tr:hover .equity-sticky-col {\n  background: #f9fafb;\n}\n\n/* Color coding for differences */\n.equity-table td.positive {\n  color: #059669;\n  font-weight: 600;\n  background-color: rgba(5, 150, 105, 0.05);\n}\n\n.equity-table td.negative {\n  color: #dc2626;\n  font-weight: 600;\n  background-color: rgba(220, 38, 38, 0.05);\n}\n\n.equity-table tbody tr:hover td.positive {\n  background-color: rgba(5, 150, 105, 0.1);\n}\n\n.equity-table tbody tr:hover td.negative {\n  background-color: rgba(220, 38, 38, 0.1);\n}\n\n.equity-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #9ca3af;\n  font-style: italic;\n}\n\n/* Loading and Error States */\n.equity-loading,\n.equity-error {\n  padding: 3rem;\n  text-align: center;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n}\n\n.equity-loading {\n  color: #6b7280;\n}\n\n.equity-error {\n  color: #dc2626;\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .equity-table-container {\n    max-height: calc(100vh - 350px);\n  }\n}\n\n@media (max-width: 768px) {\n  .equity-container {\n    padding: 1rem;\n  }\n\n  .equity-header h1 {\n    font-size: 1.5rem;\n  }\n\n  .equity-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .equity-control-group {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .equity-export-btn {\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .equity-summary-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .equity-table-container {\n    overflow-x: auto;\n  }\n\n  .equity-card-value {\n    font-size: 1.25rem;\n  }\n\n  .equity-table {\n    font-size: 0.8125rem;\n  }\n\n  .equity-table td,\n  .equity-table th {\n    padding: 0.75rem 0.875rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .equity-card-value {\n    font-size: 1.125rem;\n  }\n\n  .equity-table {\n    font-size: 0.75rem;\n    min-width: 700px;\n  }\n\n  .equity-table td,\n  .equity-table th {\n    padding: 0.625rem 0.75rem;\n  }\n}\n\n/* Dark mode support (optional, can be enabled later) */\n@media (prefers-color-scheme: dark) {\n  /* Dark mode styles can be added here if needed */\n}\n\n/* Print styles */\n@media print {\n  .equity-controls,\n  .equity-export-btn {\n    display: none;\n  }\n\n  .equity-container {\n    background: #ffffff;\n    padding: 0;\n  }\n\n  .equity-table-container {\n    box-shadow: none;\n    border: 1px solid #000;\n  }\n}\n/* ---- Deposit / Note styling ---- */\n.equity2-deposit-row {\n  background-color: #f0f9ff;\n}\n\n.equity2-deposit-row:hover {\n  background-color: #e0f2fe !important;\n}\n\n.equity2-note-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.equity2-note-deposit {\n  background-color: #dbeafe;\n  color: #1d4ed8;\n  border: 1px solid #93c5fd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
